import {ModalPresentation} from "@/api/ModalPresentationApi.ts";
import {ModalContent, ModalTarget} from "@/modal/ModalHooks.ts";

export function presentationContent(presentation: ModalPresentation): ModalContent | undefined {
    switch (presentation.type) {
        case "NONE":
            return undefined;
        case "SPELL":
            return {type: "SPELL", id: presentation.contentId, spell: presentation.spell};
        case "CHARACTER":
            return {type: "CHARACTER", id: presentation.contentId, character: presentation.character};
    }
}

export function contentTarget(content?: ModalContent): ModalTarget | undefined {
    return content ? {type: content.type, id: content.id} : undefined;
}

export function sameTarget(first?: ModalTarget, second?: ModalTarget) {
    return Boolean(first && second && first.type === second.type && first.id === second.id);
}
